module.exports = __webpack_public_path__ + "static/media/proof-of-address.1410e9f8.svg";